import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { MasterService } from 'src/app/masters/master.service';
import * as CommonConstants from '../../utils/common.constants';
import { OrganismModel } from '../organisms/organism.model';
import { AddPractitionerComponent } from '../practitioners/add-practitioner/add-practitioner.component'
import { PractitionersService } from './practitioners.service';
import { FormGroup, FormBuilder, FormControl } from '@angular/forms';
import { LoaderService } from 'src/app/common/loader.service';
import { SharedService } from 'src/app/utils/shared.service';



@Component({
  selector: 'app-practitioners',
  templateUrl: './practitioners.component.html',
  styleUrls: ['./practitioners.component.scss']
})
export class PractitionersComponent implements OnInit {

  organisms: OrganismModel[];
  townList: any = [];
  countryList: any = [];
  columnDefs: any[];
  gender: any[];
  genders: any[];
  startIndex;
  rowsPerPage;
  totalRecords;
  paginationSize = CommonConstants.PAGINATION_SIZE;
  practitionerSearchForm: FormGroup;
  rowData: any[];
  specialities: any[];
  addPractitioner;
  toggleColumn = true;
  addressTypeList : any[];
  nationalities: any[];
  newPractitioner: AddPractitionerComponent;
  priv_addPrac: any;
  @ViewChild(AddPractitionerComponent, { static: true }) set Content(newPractitionerRef) {
    this.newPractitioner = newPractitionerRef;
  }

  constructor(public router: Router, private masterService: MasterService, private practitionerService:PractitionersService
    , private formBuilder: FormBuilder, private loaderService: LoaderService,private sharedService:SharedService) {
    this.columnDefs = [
      // { headerName: 'Id', field: 'prtieId'},
      { headerName: 'Name', field: 'persoVaFirstname'},
      { headerName: 'Gender', field: 'gendeCode', valueGetter: this.genderNameValueGetter.bind(this)  },
      { headerName: 'Home Phone', field: 'persoVaHomePhone'},
      { headerName: 'Work Phone', field: 'persoVaWorkPhone' },
      { headerName: 'Mobile Phone', field: 'persoVaMobilePhone1'},
      { headerName: 'Email', field: 'persoVaEmail1'}
    ];
    this.getFromGroup();  
    this.searchPractitioners();
  }

  ngOnInit() {
    this.priv_addPrac=this.sharedService.hasPrivilege(CommonConstants.PRIV_ADD_PRACTIONER);
    this.loadMasterData();
  }

  genderNameValueGetter(params) {
    let gender;
    if(params.data.gendeCode){
      gender = params.data.gendeCode == 'M' ? "Male" : "Female";
    }
    return gender;
  }


  /**
    * Declare form group
    *  
    */
   private getFromGroup() {
    this.practitionerSearchForm = this.formBuilder.group({
      'orgsmId':  new FormControl(),
      'cotryId': new FormControl(),
      'townId' : new FormControl(),
      'persoVaFirstname': new FormControl(),
      'persoVaLastname':new FormControl(),
      'spltyId': new FormControl(),
      'nationId': new FormControl(),
      'genderCode': new FormControl(),
      'staRecCode': [true],
      'active':['A']
    })
  }

  addNewPractitioner() {
    this.newPractitioner.addPractionerTitle = true;
    this.newPractitioner.editPractionerTitle = false;
    this.router.navigate(['addPractitioner']);
  }

  loadMasterData() {
    this.masterService.getTown().subscribe(response => {
      if (response['code'] == 'S0000') {
        this.townList = response['result'];
      }
    });

    this.masterService.getCountry().subscribe(response => {
      if (response['code'] == 'S0000') {
        this.countryList = response['result'];
      }
    });
    this.masterService.getOrganisms().subscribe(response => {
      if (response && response['result']) {
        this.organisms = response['result'];
      }
    })
    this.masterService.getSpecialities().subscribe(response => {
      if (response && response['result']) {
        this.specialities = response['result'];
      }
    })
  
    this.masterService.getAddressTypes().subscribe(response => {
      if (response['code'] == 'S0000') {
        this.addressTypeList = response['result'];
      }
    });
    this.masterService.getNationality().subscribe(response => {
      if (response && response['result']) {
        this.nationalities = response['result'];
      }
    })
    this.masterService.getGender().subscribe(response => {
      if (response && response['result']) {
        this.genders = response['result'];
      }
    })
  }

  searchPractitioners() {
    this.startIndex = 0;
    this.rowsPerPage = CommonConstants.PAGINATION_SIZE;
    this.paginatedList();
    this.hideRightDiv();
    /* this.hospitalService.searchHospitals(this.hospitalSearch).subscribe(response => {
      console.log(response['result']);
      this.rowData = response['result'];
    }) */
  }

  paginatedList() {
    this.loaderService.display(true);
    this.practitionerSearchForm.patchValue({active:this.practitionerSearchForm.value.staRecCode ? 'A' :'I'})
    this.practitionerService.searchPractitioner(this.practitionerSearchForm.value, this.startIndex).subscribe(response => {
      this.loaderService.display(false);
      let result = response['result'];
      if (result) {
        this.totalRecords = result.length;
        if (!this.gender) {
          this.masterService.getGender().subscribe(response => {
            if (response && response['result']) {
              this.gender = response['result'];
              this.setPractitioners(result);
            }
          })
        } else {
          this.setPractitioners(result);
        }
      }
    },
      error => {
        this.loaderService.display(false);
      })
  }

  setPractitioners(result) {
    /* result = result.map(item => ({
      ...item,
      genderDesc: item.gendeCode ? this.gender.find(obj => obj.genderId === +item.gendeCode).description : null
    })) */
    this.rowData = result;
  }

  paginate(event: any) {
    this.startIndex = event.first;
    this.rowsPerPage = event.rows;
    this.paginatedList();
  }

  onRowClicked(event: any) {
    this.addPractitioner = true;
    this.toggleColumn = false;
    this.newPractitioner.addPractionerTitle = false;
    this.newPractitioner.editPractionerTitle = true;
    this.loadPractitionerById(event);
  }

  loadPractitionerById(event: any) {
    this.loaderService.display(true);
    this.practitionerService.getPractitionersById(event.data.prtieId).subscribe(response => {
      this.loaderService.display(false);
      this.newPractitioner.hospDepartment.departmentList = [];
      this.newPractitioner.hospAddress.addressList = [];
      if (response['code'] == 'S0000') {
        let result = response['result'];
        this.newPractitioner.practitionerForm.patchValue({
          prtieId: result["prtieId"],
          orgsmId: result["orgsmId"],
          spltyId: result["spltyId"],
          gendeCode: result["gendeCode"] ? +result["gendeCode"] : [],
          ssptyId: result["ssptyId"],
          hsptyId: result["hsptyId"],
          civilCode: +result["civilCode"],
          cotryINationality: result["cotryINationality"],
          titleId: result["titleId"],
          persoVaFirstname: result["persoVaFirstname"],
          persoVaSecondName: result["persoVaSecondName"],
          persoVaThirdName: result["persoVaThirdName"],
          persoVaLastname: result["persoVaLastname"],
          persoDtBirthDate: result["persoDtBirthDate"] ? new Date(result["persoDtBirthDate"]) :null,
          natioId: result["natioId"],
          certiId: result["certiId"],
          pacatId: result["pacatId"],
          pctypId: result["pctypId"],
          prtieDtFunctions: result["prtieDtFunctions"],
          persoVaEmail1: result["persoVaEmail1"],
          persoVaEmail2: result["persoVaEmail2"],
          persoVaMobilePhone1: result["persoVaMobilePhone1"],
          persoVaMobilePhone2: result["persoVaMobilePhone2"],
          persoVaHomePhone: result["persoVaHomePhone"],
          persoVaWorkFax: result["persoVaWorkFax"],
          persoVaWorkPhone: result["persoVaWorkPhone"],
          agmntId: result["agmntId"],
          professionalId: result["professionalId"],
          pratiqueTelemedicine: result["pratiqueTelemedicine"],
          staRecCode: result["staRecCode"] ==='A' ? true : false,
          prtieVaFunctions : result["prtieVaFunctions"]
        });
 
        result['prAddressList'] = result['prAddressList'].map(item => ({
          ...item,
          addressType: item.typeId ? this.addressTypeList.find(obj => +obj.typeId === +item.typeId).description : null,
          townName: item.townId ? this.townList.find(town => town.townId === item.townId).townDescEn : null,
          countryName: item.cotryId ? this.countryList.find(country => country.cotryId === item.cotryId).cotryDescEn : null
        })); 
        this.newPractitioner.hospDepartment.departmentList = JSON.parse(JSON.stringify(result['prDepartmentList']));
        this.sharedService.setOrganismDepartment(this.newPractitioner.hospDepartment.departmentList );
        this.newPractitioner.hospAddress.addressList = JSON.parse(JSON.stringify(result['prAddressList']));
        this.newPractitioner.phoneNos.forEach(phone => {
          phone.phone=phone.getInternationPhoneFormat(result[phone.type]);
      })
	
      }
    },
    error => {
      this.loaderService.display(false);
    })
  }

  hideRightDiv() {
    this.addPractitioner = false;
    this.toggleColumn = true;
  }

  reset(){
    this.practitionerSearchForm.reset();
    this.hideRightDiv();
  }


}
